/**门店路由 */
export default {
    name: 'store',
    path: 'store',
    meta: {title:'门店'},
    component: ()=>import('@/pages/index.vue'),
    children:[
        {
            name: 'store-list',
            path: 'list',
            meta: { title: '门店列表' },
            component: ()=>import('@/pages/store/list.vue')
        },
        {
            name: 'store-type',
            path: 'type',
            meta: { title: '门店类型' },
            component: ()=>import('@/pages/store/type.vue')
        }
    ]
    
}